import axiosInstance from "../../../interceptors/token";
import { API_BASE_URL } from "../../../constants";

export const calculateTransportTime = async (projectOrder, projectID, selectedDate, currentStartTime, preparationTime) => {
    if (!projectOrder) return 0;
    let previousProjectEndTime = null;
    const currentIndex = projectOrder.indexOf(projectID);
    
    if (currentIndex > 0) {
        const previousProjectId = projectOrder[currentIndex - 1];
        try {
            const previousTimingResponse = await axiosInstance.get(`${API_BASE_URL}projects/${previousProjectId}/werk/timing/`, { params: { date: selectedDate } });
            previousProjectEndTime = previousTimingResponse.data?.end_time || null;
        } catch (error) {
            console.log(`No timing data found for previous project ${previousProjectId}`);
        }
    } else {
        const startTime = new Date("1970-01-01T07:00:00");
        const endTime = new Date(startTime.getTime() + parseFloat(preparationTime || 0) * 60 * 60 * 1000);
        previousProjectEndTime = endTime.toTimeString().slice(0, 8);        
    }

    let transportTime = 0;

    if (previousProjectEndTime && currentStartTime) {
        const start = new Date(`1970-01-01T${currentStartTime}`);
        const end = new Date(`1970-01-01T${previousProjectEndTime}`);
        const diffInMinutes = (start - end) / 60000;
        const roundedMinutes = Math.round(diffInMinutes / 5) * 5;
        const diffInHours = roundedMinutes / 60;

        transportTime = diffInMinutes > 0 ? diffInHours.toFixed(2) : 0;
    }

    return transportTime
}